import React, { FC, ReactElement, useEffect } from 'react';
import { Alert } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Prospect } from '../../features/offerSearch/types';
import { RootState } from '../../redux/rootReducer';
import { getStateNameFromCode } from '../../util/States';
import withLocalization from '../hoc/withLocalization';
import { NavigationSteps } from '../OfferDetails/OfferNavigation';

const CurrentProspectSummary: FC<any> = (props: any): ReactElement => {
  const prospect: Prospect | undefined = useSelector((state: RootState) => state.offerDetails.prospect);
  const sessionExpired = useSelector((state: RootState) => state.sessionManager.expired);
  const currentNavigationStep = useSelector((state: RootState) => state.offerDetails.currentNavigationStep);
  const { localize } = props;
  const showProspectSummary =
    currentNavigationStep === NavigationSteps.OFFER_DESTINATION ||
    currentNavigationStep === NavigationSteps.OFEFR_DETAILS ||
    currentNavigationStep === NavigationSteps.OFFER_DATES ||
    currentNavigationStep === NavigationSteps.OFFER_ELIGIBILITY;
  let prospectSummary = `${prospect?.firstName?.toUpperCase()} ${prospect?.lastName?.toUpperCase()}`;
  const prospectFromState = prospect?.stateProvince
    ? localize(
        'preview-sales-engine.static-content.copy.Labels.labels#preview-sales-engine.static-content.copy.prospect-from-state',
        getStateNameFromCode(prospect?.stateProvince),
      )
    : '';
  prospectSummary = prospect?.stateProvince ? `${prospectSummary}  ${prospectFromState}` : prospectSummary;
  useEffect(() => {
    if (!sessionExpired) {
      if (!prospect || !prospect?.firstName || !prospect.lastName) {
        props.history.push('/');
      }
    }
  });
  return (
    <div className="container">
      {' '}
      {showProspectSummary && prospect && prospect.firstName && prospect.lastName ? (
        <Alert variant="info">
          {localize(
            'preview-sales-engine.static-content.copy.Labels.labels#preview-sales-engine.static-content.copy.prospect-details',
            prospectSummary,
          )}
        </Alert>
      ) : (
        <></>
      )}
    </div>
  );
};

export default withRouter(withLocalization(CurrentProspectSummary));
